import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_GET_SUBSCRIPTION_STATUS_BEGIN,
  USER_GET_SUBSCRIPTION_STATUS_SUCCESS,
  USER_GET_SUBSCRIPTION_STATUS_FAILURE,
  USER_GET_SUBSCRIPTION_STATUS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function getSubscriptionStatus(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_GET_SUBSCRIPTION_STATUS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${config.apiRootUrl}/subscriptions/get-subscription-status`,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_GET_SUBSCRIPTION_STATUS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_GET_SUBSCRIPTION_STATUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetSubscriptionStatusError() {
  return {
    type: USER_GET_SUBSCRIPTION_STATUS_DISMISS_ERROR,
  };
}

export function useGetSubscriptionStatus() {
  const dispatch = useDispatch();

  const { getSubscriptionStatusPending, getSubscriptionStatusError } =
    useSelector(
      (state) => ({
        getSubscriptionStatusPending: state.user.getSubscriptionStatusPending,
        getSubscriptionStatusError: state.user.getSubscriptionStatusError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(getSubscriptionStatus(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetSubscriptionStatusError());
  }, [dispatch]);

  return {
    getSubscriptionStatus: boundAction,
    getSubscriptionStatusPending,
    getSubscriptionStatusError,
    dismissGetSubscriptionStatusError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_GET_SUBSCRIPTION_STATUS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getSubscriptionStatusPending: true,
        getSubscriptionStatusError: null,
      };

    case USER_GET_SUBSCRIPTION_STATUS_SUCCESS:
      // The request is success
      return {
        ...state,
        getSubscriptionStatusPending: false,
        getSubscriptionStatusError: null,
      };

    case USER_GET_SUBSCRIPTION_STATUS_FAILURE:
      // The request is failed
      return {
        ...state,
        getSubscriptionStatusPending: false,
        getSubscriptionStatusError: action.data.error,
      };

    case USER_GET_SUBSCRIPTION_STATUS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getSubscriptionStatusError: null,
      };

    default:
      return state;
  }
}
